import React, { useRef, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const useReCaptcha = () => {
  const recaptchaRef = useRef(null);

  const executeRecaptcha = async (action) => {
    if (recaptchaRef.current) {
      try {
        const token = await recaptchaRef.current.executeAsync();
        console.log(`reCAPTCHA token generated for action '${action}':`, token ? token.substring(0, 10) + "..." : "none");
        return token;
      } catch (error) {
        console.error('ReCAPTCHA execution error:', error);
        // throw error;
      }
    } else {
      console.error('ReCAPTCHA reference is not available');
      throw new Error('ReCAPTCHA reference is not available');
    }
  };

  return { recaptchaRef, executeRecaptcha };
};

export const RecaptchaComponent = React.forwardRef((props, ref) => {
  return (
    <ReCAPTCHA
      ref={ref}
      size="invisible"
      sitekey={RECAPTCHA_SITE_KEY}
      badge="bottomright"
    />
  );
});

export default useReCaptcha;